import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './slider.css';
import swiperStyles from 'swiper/swiper-bundle.min.css';
// TODO we are using a duplicate version of swiper here for now. We should install the latest version via npm and refactor the other places to use the new version.
import '../../js/vendor/swiper-element-bundle.min.js';

/**
 * @property {number} slidesPerView
 * @property {number} spaceBetween
 * @property {object} breakpoints
 * @property {boolean} pagination
 * @property {boolean} navigation
 * @property {boolean} scrollbar
 */
export default class Slider extends TemplateElement {
    swiper;

    constructor() {
        super({ styles: [swiperStyles, style], shadowRender: true });
    }

    properties() {
        return {
            slideSelector: 'div',
            slidesPerView: 1.2,
            spaceBetween: 16,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
            pagination: true,
            navigation: false,
            scrollbar: false,
        };
    }

    connected() {
        const swiperEl = this.$refs.swiper;

        const swiperParams = {
            pagination: {
                el: this.$refs.pagination,
                type: 'bullets',
                clickable: true,
            },
            grabCursor: true,
            slidesPerView: this.slidesPerView,
            spaceBetween: this.spaceBetween,
            breakpoints: this.breakpoints,
        };

        Object.assign(swiperEl, swiperParams);
        swiperEl.initialize();
    }

    template() {
        const slides = Array.from(Array(this.childElementCount || 0).keys());
        return html`
            <swiper-container
                ref="swiper"
                init="false"
                navigation="${this.navigation}"
                pagination="${this.pagination}"
                scrollbar="${this.scrollbar}"
            >
                ${slides.map((slide) => html` <swiper-slide><slot name="slide-${slide}"></slot></swiper-slide> `)}
            </swiper-container>
            ${when(this.pagination, html` <div ref="pagination" class="swiper-paginationNOT pagination"></div> `)}
            ${when(
                this.navigation,
                html`
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    `,
            )}
            ${when(this.scrollbar, html`<div class="swiper-scrollbar"></div>`)}
        `;
    }
}

defineElement('mb-slider', Slider);
